module.exports = "<img class=\"img img-responsive\"\r\n     ng-src=\"{{vm.imageSource}}\">\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-default btn-round\"\r\n          ng-click=\"vm.deleteImage()\">Cancella immagine\r\n  </button>\r\n  <button class=\"btn btn-primary btn-round\"\r\n          ng-click=\"vm.dismiss()\"><span class=\"ti ti-close\"></span> Chiudi\r\n  </button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/imageDetail/imageDetail.html
// module id = 496
// module chunks = 0